import { useState } from 'react';

import endpoints from '../../../../api/endpoints';
import { nortadaLogger } from '../../../common/logger';
import { handleResponseError } from '../../../../api/handleResponseError';
import { fetchWithTokenRefresh } from '../../../../api/fetchWithTokenRefresh';

import { ClientInfo } from './interfaces';

export const useGetClientInfo = () => {
  const [clientInfo, setClientInfo] = useState<ClientInfo>({
    msisdn: '',
    callback: '',
    name: '',
    emailAddress: '',
    country: ''
  });
  const [clientInfoLoading, setLoading] = useState<boolean>(false);
  const [clientInfoError, setError] = useState<boolean>(false);

  const handleGetClientInfo = async () => {
    try {
      setLoading(true);
      setError(false);

      const response = await fetchWithTokenRefresh(endpoints.clientInfo);

      if (response.status !== 200) {
        await handleResponseError(response);
      }

      const jsonResponse = await response.json();

      setClientInfo(jsonResponse);
      setLoading(false);
    } catch (e) {
      nortadaLogger.error(e);
      setError(true);
    }
  };

  return { clientInfo, clientInfoLoading, clientInfoError, handleGetClientInfo };
};
